import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const AuthenticatedNavigation = ({ userRole = 'candidate', matchCount = 0 }) => {
  const location = useLocation();
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  // Load unread notifications count from Supabase
  useEffect(() => {
    const loadUnreadCount = async () => {
      if (!user) return;

      try {
        const { notificationsService } = await import('../../services/supabaseService');
        const notifications = await notificationsService?.getByUserId(user?.id);
        const unread = notifications?.filter(n => !n?.isRead)?.length;
        setUnreadCount(unread);
      } catch (err) {
        console.error('Error loading notifications:', err);
      }
    };

    loadUnreadCount();
  }, [user]);

  const candidateNavItems = [
    { label: 'Feed', path: '/opportunity-feed', icon: 'Briefcase' },
    { label: 'Matches', path: '/match-management', icon: 'Users', badge: matchCount },
    { label: 'Messages', path: '/secure-chat-interface', icon: 'MessageSquare' },
    { label: 'Notifications', path: '/notification-center', icon: 'Bell', badge: unreadCount },
    { label: 'Profile', path: '/anonymous-profile-generator', icon: 'User' },
    { label: 'Settings', path: '/user-preferences-center', icon: 'Settings' },
  ];

  const employerNavItems = [
    { label: 'Dashboard', path: '/employer-dashboard', icon: 'LayoutDashboard' },
    { label: 'Candidates', path: '/employer-dashboard#candidates', icon: 'Users' },
    { label: 'Notifications', path: '/notification-center', icon: 'Bell', badge: unreadCount },
    { label: 'Settings', path: '/user-preferences-center', icon: 'Settings' },
  ];

  const navItems = userRole === 'employer' ? employerNavItems : candidateNavItems;

  const isActive = (path) => {
    if (path?.includes('#')) {
      return location?.pathname === path?.split('#')?.[0];
    }
    return location?.pathname === path;
  };

  return (
    <nav className="authenticated-nav">
      <div className="authenticated-nav-container">
        <div className="authenticated-nav-header">
          <div className="authenticated-nav-logo">
            <Icon name="Shield" size={24} color="#FFFFFF" />
          </div>
          <span className="authenticated-nav-logo-text">BlinD</span>
        </div>

        <div className="authenticated-nav-menu">
          {navItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`authenticated-nav-item ${isActive(item?.path) ? 'active' : ''}`}
            >
              <div className="relative">
                <Icon name={item?.icon} size={24} />
                {item?.badge > 0 && (
                  <span className="authenticated-nav-badge">{item?.badge}</span>
                )}
              </div>
              <span className="authenticated-nav-item-label">{item?.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default AuthenticatedNavigation;